import EventTracker from "../eventTracker";
import EventTypes from "../constants/EventTypes";

export function loopableSurveyResponse(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse = false, aChildSurveyResponseId = null, aIndex = null){
  EventTracker.track(EventTypes.FETCH_CHILD_SURVEY);
  let query = `
    query loop_survey_response ($company_id: ID!, $user_id: ID!, $survey_response_id: ID!, $loop_reference: String!, $index: Int, $child_survey_response_id: ID, $is_test_response: Boolean) {
      loop_survey_response (company_id: $company_id, user_id: $user_id, survey_response_id: $survey_response_id, loop_reference: $loop_reference, index: $index, child_survey_response_id: $child_survey_response_id, is_test_response: $is_test_response) {
        index
        total
        status
        child_survey_response_id
        completed_loopable_entries
        important_questions {
          key
          label
          survey_response_detail_value
        }
        child_survey_response {
          id
          complete
          progress
          created_at
          lock_state
          updated_at
          completed_at
          survey {
            id
            name
          }
          important_questions {
            key
            label
            survey_response_detail_value
          }
        }
      }
    }
  `;
  let variables = {};

  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['user_id'] = aPatientId;
    variables['survey_response_id'] = aSurveyResponseId;
    variables['is_test_response'] = aIsTestResponse;
    variables['loop_reference'] = aLoopReference;
    
    if(aChildSurveyResponseId){
      variables['child_survey_response_id'] = aChildSurveyResponseId;
    }
    if(aIndex){
      variables['index'] = aIndex;
    }
    return global.api.post("/queries", { query, variables })
  };
}

export function loopableSurveyResponses(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse = false, aLimit = 10, aOffset = 0){
  EventTracker.track(EventTypes.FETCH_CHILD_SURVEYS);
  let query = `
    query loop_survey_responses ($company_id: ID!, $user_id: ID!, $survey_response_id: ID!, $loop_reference: String!, $limit: Int, $offset: Int, $is_test_response: Boolean) {
      loop_survey_responses (company_id: $company_id, user_id: $user_id, survey_response_id: $survey_response_id, loop_reference: $loop_reference, limit: $limit, offset: $offset, is_test_response: $is_test_response) {
        total
        completed_loopable_entries
        array {
          index
          status
          child_survey_response_id
          completed_loopable_entries
          important_questions {
            key
            label
            survey_response_detail_value
          }
          child_survey_response {
            id
            complete
            progress
            created_at
            lock_state
            updated_at
            completed_at
            survey {
              id
              name
            }
            important_questions {
              key
              label
              survey_response_detail_value
            }
          }
        }
      }
    }
  `;
  let variables = {};

  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['user_id'] = aPatientId;
    variables['survey_response_id'] = aSurveyResponseId;
    variables['loop_reference'] = aLoopReference;
    variables['is_test_response'] = aIsTestResponse;
    variables['limit'] = aLimit;
    variables['offset'] = aOffset;
    return global.api.post("/queries", { query, variables })
  };
}

export function getSurveyResponseDetails(aSurveyResponseId, aQuestionKey, aIncludeDeleted = false){
  EventTracker.track(EventTypes.FETCH_SURVEY_RESPONSE_DETAILS);
  let query = `
    query GetSurveyResponseDetail($response_id: ID!, $company_id: ID!, $key: String!, $include_deleted: Boolean) {
      getSurveyResponseDetail(response_id: $response_id, company_id: $company_id, key: $key, include_deleted: $include_deleted) {
        array {
          id
          key
          value
          values {
            key
            value
          }
          other
          other_label
          skip
          other_value
          created_at
          deleted_at
          locale
          skipped
        }
        total
        question {
          key
          number_of_columns
          page_number
          step
          regex
          js_regex
          label_position
          extra_questions
          required_questions
          answer_label_position
          label
          labels
          type
          choices
          other
          other_label
          skip
          nested
          min_value
          max_value
          min_warning
          max_warning
          min_label
          max_label
          validation
          uncertain
          default_value
          default_values {
            key
            value
          }
          default_other
          list {
            label
            value
          }
          country_code
          dynamic_list_id
          default_medications
          is_sensitive_data_question
          large_text_area
          is_loopable
          survey_index
          survey_keyword
          survey_id
          survey_reference
          child_survey_id
          child_survey_reference
          unresolvable
          minimum_loopable_entries
          maximum_loopable_entries
          completed_loopable_entries
          total
        }
      }
    }
  `;
  let variables = {};
  return (dispatch, getState) => {
    let state = getState();
    variables['company_id'] = state.company && state.company.company && state.company.company.id;
    variables['key'] = aQuestionKey;
    variables['response_id'] = aSurveyResponseId;
    variables['include_deleted'] = aIncludeDeleted;
    return global.api.post("/queries", { query, variables })
  };
}

export function createLoopableSurveyResponse(aPatientId, aSurveyResponseId, aLoopReference, aIsTestResponse = false){
  EventTracker.track(EventTypes.CREATE_CHILD_SURVEY);
  let graphQLQuery = `
    mutation CreateLoopSurveyResponse ($createLoopSurveyResponseInput: CreateLoopSurveyResponseInput!) {
      createLoopSurveyResponse (input: $createLoopSurveyResponseInput) {
        index
        total
        status
        child_survey_response_id
        completed_loopable_entries
        important_questions {
          key
          label
          survey_response_detail_value
        }
        child_survey_response {
          id
          complete
          progress
          created_at
          lock_state
          updated_at
          completed_at
          survey {
            id
            name
          }
          important_questions {
            key
            label
            survey_response_detail_value
          }
        }
      }
    }
  `;
  
  return (dispatch, getState) => {
    let state = getState();
    let operationName = 'CreateLoopSurveyResponse';
    
    let variables = {
      createLoopSurveyResponseInput: {
        company_id: state.company && state.company.company && state.company.company.id,
        user_id: aPatientId,
        survey_response_id: aSurveyResponseId,
        is_test_response: aIsTestResponse,
        loop_reference: aLoopReference
      }
    };
    return global.api.post("/queries", {query: graphQLQuery, variables, operationName});
  };
}

export function deleteLoopableSurveyResponse(aPatientId, aSurveyResponseId, aChildSurveyResponseId = null, aIsTestResponse = false, aLoopReference = null, aIndex = null){
  EventTracker.track(EventTypes.DELETE_CHILD_SURVEY);
  let graphQLQuery = `
    mutation DeleteLoopSurveyResponse ($deleteLoopSurveyResponseInput: DeleteLoopSurveyResponseInput!) {
      deleteLoopSurveyResponse (input: $deleteLoopSurveyResponseInput) {
        total
        completed_loopable_entries
      }
    }
  `;
  
  return (dispatch, getState) => {
    let state = getState();
    let operationName = 'DeleteLoopSurveyResponse';
    
    let variables = {
      deleteLoopSurveyResponseInput: {
        company_id: state.company && state.company.company && state.company.company.id,
        user_id: aPatientId,
        survey_response_id: aSurveyResponseId,
        loop_reference: aLoopReference,
        child_survey_response_id: aChildSurveyResponseId,
        is_test_response: aIsTestResponse,
        index: aIndex
      }
    };
    return global.api.post("/queries", {query: graphQLQuery, variables, operationName});
  };
}

export function deleteSurveyResponseDetail(aSurveyResponseDetailId){
  EventTracker.track(EventTypes.DELETE_SURVEY_RESPONSE_DETAIL);
  let graphQLQuery = `
    mutation DeleteSurveyResponseDetail($surveyResponseDetailId: ID!, $companyId: ID!) {
      deleteSurveyResponseDetail(input: {
        survey_response_detail_id: $surveyResponseDetailId
        company_id: $companyId
      }) {
        deleted_id
      }
    }
  `;

  return (dispatch, getState) => {
    let state = getState();
    let variables = {
      companyId: state.company && state.company.company && state.company.company.id,
      surveyResponseDetailId: aSurveyResponseDetailId
    };

    return global.api.post("/queries", { query: graphQLQuery, variables });
  };
}

export function restoreSurveyResponseDetail(aSurveyResponseDetailId){
  EventTracker.track(EventTypes.RESTORE_SURVEY_RESPONSE_DETAIL);
  let graphQLQuery = `
    mutation RestoreSurveyResponseDetail($surveyResponseDetailId: ID!, $companyId: ID!) {
      restoreSurveyResponseDetail(input: {
        survey_response_detail_id: $surveyResponseDetailId
        company_id: $companyId
      }) {
        restored_id
      }
    }
  `;

  return (dispatch, getState) => {
    let state = getState();
    let variables = {
      companyId: state.company && state.company.company && state.company.company.id,
      surveyResponseDetailId: aSurveyResponseDetailId
    };
    return global.api.post("/queries", { query: graphQLQuery, variables });
  };
}
